import React, { useState, useEffect, use } from "react";
import "../../../assets/css/gamesCss/List/singlySearching.css";
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { Col } from "reactstrap"
import { motion } from "framer-motion";
import { useDarkMode } from "../../../context/DarkModeProvider";
import { useLanguage } from "context/LanguageProvider";
import "../../../assets/css/colors.css"

const LinkedListSearchGame = () => {


    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));
    const { selLanguage, toggleLanguage, isLoading } = useLanguage();
    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }

    const TARGET_POSITION = 6;
    const TOTAL_NODES = 9;
    const QUESTION_TIME = 7;

    const [currentPosition, setCurrentPosition] = useState(0);
    const [lives, setLives] = useState(3);
    const [showQuestion, setShowQuestion] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [timeLeft, setTimeLeft] = useState(QUESTION_TIME);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const [usedQuestions, setUsedQuestions] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [showFeedback, setShowFeedback] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { darkMode } = useDarkMode();

    const mission = selLanguage ? "Κάνε αναζήτηση του αριθμού 5 σειριακά. Για κάθε κόμβο που θα επιλέγεις θα πρέπει να απαντάς μία ερώτηση θεωρίας η οποία θα σου επιτρέπει να προχωράς αν έχεις απαντήσει σωστά." : "Search for the number 5 sequentially. For each node you select, you must answer a theory question, which will allow you to continue only if you answer correctly."

    const questions = [
        {
            question: selLanguage
                ? "Η χρονική πολυπλοκότητα της αναζήτησης σε απλά συνδεδεμένη λίστα είναι O(1)"
                : "The time complexity of searching in a singly linked list is O(1).",
            answer: false,
            explanation: selLanguage
                ? "Η χρονική πολυπλοκότητα είναι O(n), όχι O(1)"
                : "The time complexity is O(n), not O(1)."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική αναζήτηση χρησιμοποιούμε βρόχο while για να διατρέξουμε τη λίστα"
                : "In iterative search, we use a while loop to traverse the list.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Χρησιμοποιούμε while loop"
                : "Correct! We use a while loop."
        },
        {
            question: selLanguage
                ? "Η αναδρομική αναζήτηση απαιτεί λιγότερο χώρο μνήμης από την επαναληπτική"
                : "Recursive search requires less memory than iterative search.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η αναδρομική χρησιμοποιεί επιπλέον χώρο στη στοίβα"
                : "Wrong! Recursion uses extra space on the call stack."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική αναζήτηση, ο δείκτης current αρχικοποιείται στο head της λίστας"
                : "In iterative search, the pointer current is initialized to the head of the list.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Ξεκινάμε από τον πρώτο κόμβο"
                : "Correct! We start from the first node."
        },
        {
            question: selLanguage
                ? "Αν φτάσουμε σε κόμβο με current == NULL, έχουμε βρει το στοιχείο"
                : "If we reach a node where current == NULL, we have found the element.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! NULL σημαίνει ότι δεν βρέθηκε το στοιχείο"
                : "Wrong! NULL means the element was not found."
        },
        {
            question: selLanguage
                ? "Η χειρότερη περίπτωση αναζήτησης συμβαίνει όταν το στοιχείο βρίσκεται στο τέλος ή δεν υπάρχει"
                : "The worst-case search occurs when the element is at the end or does not exist.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Πρέπει να διατρέξουμε ολόκληρη τη λίστα"
                : "Correct! We must traverse the entire list."
        },
        {
            question: selLanguage
                ? "Στην αναδρομική αναζήτηση, η περίπτωση βάσης είναι όταν βρούμε το στοιχείο ή φτάσουμε σε NULL"
                : "In recursive search, the base case is when we find the element or reach NULL.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτές είναι οι δύο περιπτώσεις βάσης"
                : "Correct! Those are the two base cases."
        },
        {
            question: selLanguage
                ? "Η αναδρομική αναζήτηση μπορεί να προκαλέσει stack overflow σε πολύ μεγάλες λίστες"
                : "Recursive search can cause a stack overflow on very large lists.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Λόγω του recursion stack"
                : "Correct! Because of the recursion stack."
        },
        {
            question: selLanguage
                ? "Στην επαναληπτική μέθοδο, μετακινούμαστε στον επόμενο κόμβο με current = current->next"
                : "In the iterative method, we move to the next node with current = current->next.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Αυτός είναι ο τρόπος μετακίνησης"
                : "Correct! That is how we move through the list."
        },
        {
            question: selLanguage
                ? "Η αναζήτηση σε ταξινομημένη συνδεδεμένη λίστα έχει πάντα πολυπλοκότητα O(log n)"
                : "Searching in a sorted linked list always has time complexity O(log n).",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Παραμένει O(n) γιατί δεν έχουμε άμεση πρόσβαση"
                : "Wrong! It is still O(n) because we have no random access."
        },
        {
            question: selLanguage
                ? "Σε διπλά συνδεδεμένη λίστα μπορούμε να ψάξουμε και από το τέλος προς την αρχή"
                : "In a doubly linked list, we can also search from the end toward the beginning.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Έχουμε prev δείκτες"
                : "Correct! We have prev pointers."
        },
        {
            question: selLanguage
                ? "Η επαναληπτική μέθοδος είναι πιο αργή από την αναδρομική για μικρές λίστες"
                : "The iterative method is slower than the recursive one for small lists.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Η επαναληπτική είναι συνήθως ταχύτερη"
                : "Wrong! The iterative method is usually faster."
        },
        {
            question: selLanguage
                ? "Αν η λίστα έχει n κόμβους, στη μέση περίπτωση ψάχνουμε n/2 κόμβους"
                : "If the list has n nodes, in the average case we search about n/2 nodes.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Κατά μέσο όρο βρίσκουμε το στοιχείο στη μέση"
                : "Correct! On average, we find the element in the middle."
        },
        {
            question: selLanguage
                ? "Η συνάρτηση αναζήτησης επιστρέφει τον δείκτη του κόμβου ή NULL αν δεν βρεθεί"
                : "The search function returns a pointer to the node, or NULL if it is not found.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Επιστρέφουμε Node* ή NULL"
                : "Correct! We return a Node* or NULL."
        },
        {
            question: selLanguage
                ? "Μπορούμε να βελτιώσουμε την αναζήτηση σε O(1) με skip lists"
                : "We can improve search to O(1) using skip lists.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Skip lists δίνουν O(log n), όχι O(1)"
                : "Wrong! Skip lists give O(log n), not O(1)."
        },
        {
            question: selLanguage
                ? "Στην αναδρομική μέθοδο, καλούμε τη συνάρτηση με current->prev"
                : "In the recursive method, we call the function with current->prev.",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Καλούμε με current->next"
                : "Wrong! We call it with current->next."
        },
        {
            question: selLanguage
                ? "Η αναζήτηση σε κυκλική λίστα χρειάζεται ειδικό έλεγχο για αποφυγή ατέρμονου βρόχου"
                : "Searching in a circular list needs a special check to avoid an infinite loop.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Πρέπει να κρατάμε το head για σύγκριση"
                : "Correct! We must keep the head for comparison."
        },
        {
            question: selLanguage
                ? "Ο χώρος που χρειάζεται η επαναληπτική μέθοδος είναι O(n)"
                : "The space required by the iterative method is O(n).",
            answer: false,
            explanation: selLanguage
                ? "Λάθος! Χρειάζεται O(1) επιπλέον χώρο"
                : "Wrong! It needs only O(1) extra space."
        },
        {
            question: selLanguage
                ? "Στην αναδρομή, κάθε κλήση προσθέτει ένα frame στη στοίβα κλήσεων"
                : "In recursion, each call adds a frame to the call stack.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Γι' αυτό χρησιμοποιεί O(n) χώρο"
                : "Correct! That’s why it uses O(n) space."
        },
        {
            question: selLanguage
                ? "Αν ελέγχουμε current->data == target πριν τον έλεγχο NULL, μπορεί να έχουμε segmentation fault"
                : "If we check current->data == target before checking for NULL, we may get a segmentation fault.",
            answer: true,
            explanation: selLanguage
                ? "Σωστό! Πρέπει πρώτα να ελέγξουμε αν current != NULL"
                : "Correct! We must first check that current != NULL."
        }
    ];


    useEffect(() => {
        setTimeout(() => {
            setShowError(false);
        }, 2700);
    }, []);

    useEffect(() => {
        if (lives <= 0) {
            setShowGameOver(true);
        }
    }, [lives]);

    useEffect(() => {
        if (currentPosition === TARGET_POSITION) {
            setShowGameWon(true);
        }
    }, [currentPosition]);


    useEffect(() => {
        let timer;
        if (showQuestion && timeLeft > 0 && !showFeedback) {
            timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
        } else if (showQuestion && timeLeft === 0 && !showFeedback) {
            handleTimeout();
        }
        return () => clearTimeout(timer);
    }, [showQuestion, timeLeft, showFeedback]);

    const getRandomQuestion = () => {
        const availableQuestions = questions.filter(
            (_, index) => !usedQuestions.includes(index)
        );

        if (availableQuestions.length === 0) {
            setUsedQuestions([]);
            return questions[Math.floor(Math.random() * questions.length)];
        }

        const randomIndex = Math.floor(Math.random() * availableQuestions.length);
        const selectedQuestion = availableQuestions[randomIndex];
        const originalIndex = questions.indexOf(selectedQuestion);

        setUsedQuestions([...usedQuestions, originalIndex]);
        return selectedQuestion;
    };

    const handleNodeClick = (position) => {
        if (showQuestion || position < currentPosition) return;

        // Αν πάτησε λάθος κόμβο (όχι τον επόμενο στη σειρά)
        if (position !== currentPosition) {
            setLives(lives - 1);
            setErrorMessage(selLanguage ? "Λάθος επιλογή κόμβου! Σου απομένουν " + (lives - 1) + " ζωές." : "Wrong node selection! You have " + (lives - 1) + " lives left.");
            setShowError(true);
            return;
        }

        const question = getRandomQuestion();
        setCurrentQuestion(question);
        setShowQuestion(true);
        setTimeLeft(QUESTION_TIME);
        setSelectedAnswer(null);
        setShowFeedback(false);
    };

    const handleAnswer = (answer) => {
        setSelectedAnswer(answer);
        setShowFeedback(true);

        setTimeout(() => {
            if (answer === currentQuestion.answer) {
                setCurrentPosition(currentPosition + 1);
            } else {
                setLives(lives - 1);
            }
            setShowQuestion(false);
            setShowFeedback(false);
            setSelectedAnswer(null);
        }, 2000);
    };

    const handleTimeout = () => {
        setSelectedAnswer(null);
        setShowFeedback(true);

        setTimeout(() => {
            setLives(lives - 1);
            setShowQuestion(false);
            setShowFeedback(false);
        }, 2000);
    };

    const resetGame = () => {
        setCurrentPosition(0);
        setLives(3);
        setShowQuestion(false);
        setCurrentQuestion(null);
        setTimeLeft(QUESTION_TIME);
        setShowGameOver(false);
        setShowGameWon(false);
        setUsedQuestions([]);
        setSelectedAnswer(null);
        setShowFeedback(false);
    };

    const renderNodes = () => {
        const nodes = [];
        for (let i = 0; i < TOTAL_NODES; i++) {
            const isActive = i === currentPosition;
            const isPassed = i < currentPosition;
            const isTarget = i === TARGET_POSITION - 1;

            nodes.push(
                <div key={i} className="singlyListnode-container">
                    <div
                        className={`singlyListnode-node ${isActive ? 'active' : ''} ${isPassed ? 'passed' : ''} ${isTarget ? 'target' : ''}`}
                        onClick={() => handleNodeClick(i)}
                        style={{
                            cursor: isPassed ? 'not-allowed' : 'pointer',
                            opacity: isPassed ? 0.7 : 1
                        }}
                    >
                        <span className="node-value">{i}</span>
                    </div>
                    {i < TOTAL_NODES - 1 && (
                        <div className="arrow">
                            <div className="arrow-line"></div>
                            <div className="arrow-head"></div>
                        </div>
                    )}
                </div>
            );
        }
        return nodes;
    };

    return (
        <div
            className="main-content singlyIntroContainer"
            style={{
                background: darkMode ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)" : "var(--lightModeGameBackground)"
            }}
        >
            <GameOverModal
                isVisible={showGameOver}
                onPlayAgain={resetGame}
            />

            <GameWonModal
                isVisible={showGameWon}
                onPlayAgain={resetGame}
            />
            <div className="max-w-7xl mx-auto">
                <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    {/* Lives Display */}
                    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "right",
                            gap: "12px"
                        }}>

                            <div style={{
                                display: "flex",
                                gap: "6px",
                                alignItems: "center"
                            }}>
                                {[1, 2, 3].map((heartNum) => (
                                    <div
                                        key={heartNum}
                                        style={{
                                            fontSize: "24px",
                                            filter: lives >= heartNum
                                                ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                                : "grayscale(100%) opacity(0.3)",
                                            transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                            transition: "all 0.3s ease",
                                            animation: lives >= heartNum ? "heartbeat 2s ease-in-out infinite" : "none"
                                        }}
                                    >
                                        ❤️
                                    </div>
                                ))}
                            </div>

                        </div>

                        <style>{`
                        @keyframes heartbeat {
                            0%, 100% { transform: scale(1); }
                            50% { transform: scale(1.1); }
                        }
                        @keyframes pulse {
                            0%, 100% { opacity: 1; }
                            50% { opacity: 0.5; }
                        }
                        .checking-animation {
                            animation: pulse 1s ease-in-out infinite;
                        }
                    `}</style>
                    </div>
                    <br />

                    {/* Instructions */}
                    <div className="singlyintroProm">
                        {mission}
                    </div>

                    {/* Linked List Visualization */}
                    <div className="singlyIntroFrame">
                        <div className="Singlylinked-list-container">
                            {renderNodes()}
                        </div>
                    </div>

                    {/* Question Modal */}
                    {
                        showQuestion && (
                            <div
                                className="singlyIntroModal-overlay"

                            >
                                <div
                                    className="singlyIntroModal-container"
                                    style={{
                                        background: darkMode ? "linear-gradient(145deg, #1f2937 0%, #374151 100%)" : "var(--lightModeModal)"
                                    }}>
                                    <div className="singlyIntroModal-timer-bar">
                                        <div
                                            className="singlyIntroModal-timer-fill"
                                            style={{ width: `${(timeLeft / QUESTION_TIME) * 100}%` }}
                                        ></div>
                                    </div>

                                    <div className="singlyIntroModal-timer-display">

                                        <span className="singlyIntroModal-timer-text">{timeLeft}s</span>
                                    </div>

                                    <h3 className="singlyIntroModal-question-text">{currentQuestion?.question}</h3>

                                    {showFeedback ? (
                                        <div className={`singlyIntroModal-feedback ${selectedAnswer === null ? 'timeout' :
                                            selectedAnswer === currentQuestion?.answer ? 'correct' : 'wrong'
                                            }`}>
                                            {selectedAnswer === null ? (
                                                <>
                                                    <div className="singlyIntroModal-feedback-icon">⏰</div>
                                                    <p className="singlyIntroModal-feedback-title">{selLanguage ? "Ο χρόνος τελείωσε!" : "Time's up!"}
                                                    </p>
                                                    <p className="singlyIntroModal-explanation">{currentQuestion?.explanation}</p>
                                                </>
                                            ) : selectedAnswer === currentQuestion?.answer ? (
                                                <>
                                                    <p className="singlyIntroModal-feedback-title">{selLanguage ? "Σωστή απάντηση!" : "Correct answer!"}</p>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="singlyIntroModal-feedback-title">{selLanguage ? "Λάθος απάντηση!" : "Wrong answer!"}</p>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="singlyIntroModal-answer-buttons">
                                            <button
                                                className="singlyIntroModal-answer-button singlyIntroModal-true-button"
                                                onClick={() => handleAnswer(true)}
                                            >
                                                <span>{selLanguage ? "Σωστό" : "Correct"}</span>
                                            </button>
                                            <button
                                                className="singlyIntroModal-answer-button singlyIntroModal-false-button"
                                                onClick={() => handleAnswer(false)}
                                            >
                                                <span>{selLanguage ? "Λάθος" : "Wrong"}</span>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    }


                    {/* Error Message */}
                    {showError && (
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            style={{
                                background: '#fee2e2',
                                borderRadius: '15px',
                                padding: '20px',
                                marginBottom: '20px',
                                border: '2px solid #dc2626',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >

                            <p style={{ color: '#991b1b', margin: 0 }}>
                                {errorMessage}
                            </p>
                        </motion.div>
                    )}


                    {/* Reset Button 
                    <div className="button-container">
                        <button
                            onClick={resetGame}
                            style={{
                                background: "linear-gradient(135deg, #b81e1eff 0%, #7c0505ff 100%)",
                                color: "white",
                                border: "none",
                                borderRadius: "16px",
                                padding: "14px 28px",
                                fontSize: "1rem",
                                fontWeight: 600,
                                cursor: "pointer",
                                boxShadow: "0 10px 25px rgba(184, 30, 30, 0.3), 0 0 0 1px rgba(184, 30, 30, 0.2)",
                                transition: "all 0.3s ease",
                                transform: "scale(1)"
                            }}
                            onMouseEnter={(e) => {

                                e.target.style.transform = "scale(1.02)";

                            }}
                            onMouseLeave={(e) => {

                                e.target.style.transform = "scale(1)";

                            }}
                        >
                            {selLanguage ? "Επανεκκίνηση Παιχνιδιού" : "Restart Game"}
                        </button>
                        
                    </div>
                    */}
                </Col >
            </div >
        </div >
    );
};

export default LinkedListSearchGame;